<template>
    <div>
        <div class="row">
            <div class="col-2">
                <div class="text-primary">
                    <h3> {{ $t('product.title') }} </h3>
                </div>
            </div>
            <div class="col-2">
                <b-form-select>
                    <b-form-select-option value="foiz" >Barchasi</b-form-select-option>
                    <b-form-select-option value="miqdor" >Miqdorda</b-form-select-option>
                </b-form-select>
            </div>
        </div>

        <div class="divider mt-3"></div>

        <TodaySaleStat />

        <div class="form-row mt-3">
            <div class="col-3">
                <b-form-input placeholder="mahsulotlar" />
            </div>
            <div class="col-2 offset-3">
                <b-form-select>
                    <b-form-select-option>Barchasi</b-form-select-option>
                </b-form-select>
            </div>
            <div class="col-4">
                <b-form-select>
                    <b-form-select-option>Ko'p foyda keltirayotgan mahsulotlar</b-form-select-option>
                </b-form-select>
            </div>
        </div>

        <div class="form-row mt-3">
            <table class="w-100">
                <thead class="card-dark">
                <tr style="height: 50px">
                    <td>#</td>
                    <td>Mahsulotlar</td>
                    <td>Miqdor</td>
                    <td>Kelish narxi</td>
                    <td>Sotish narxi</td>
                    <td>Summa</td>
                    <td>Foyda</td>
                </tr>
                </thead>
                <tbody>
                <tr style="height: 50px; background-color: #c7c6c6">
                    <td>1</td>
                    <td>Kaptiva 3.2 / Masla filtr / Mannol</td>
                    <td>98 dona</td>
                    <td>30 000 UZS</td>
                    <td>35 000 UZS</td>
                    <td>315 000 UZS</td>
                    <td>45 000 UZS</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import TodaySaleStat from "@/components/TodaySaleStat.vue";

export default {
    name: "PurchaseStat",
    components: {TodaySaleStat}
}
</script>

<style scoped>

.divider {
    border-bottom: 1px solid #d2d2d2 !important;
    width: 100%;
}

.card-dark {
    background-color: #e2e0e0;
    border-radius: 5px;
}
</style>
